<template>
  <div class="lk-container">
    <div v-if="!complete && systemStatus < 10">
      <h1 class="title">{{ $t("register end") }}</h1>
      <p class="paragraph">
        {{ $t("go back correct") }}
      </p>
      <button class="button form__button" @click="completeRegister">
        {{ $t("complete registration") }}
      </button>
    </div>
    <div v-else>
      <h1 class="title">
        {{ $t("application accepted") }}
      </h1>
      <p class="paragraph">
        {{ $t("check data/ prepare docs") }}
      </p>
      <p class="paragraph">
        {{ $t("application status track") }}
      </p>
      <p class="paragraph">
        {{ $t("questions by phone") }} <br />
        {{ $t("contact phone / email") }}
        <a href="mailto: sales@fhs.kz">sales@fhs.kz</a>
      </p>
    </div>
  </div>
</template>

<script>
import RegFormMixin from "../form_mixin";
import { FhsAxios } from "../../../services/axios";

export default {
  mixins: [RegFormMixin],
  data() {
    return {
      complete: false
    };
  },
  methods: {
    completeRegister() {
      this.$toasted.clear();
      this.$toasted.show(this.$t("loading"), { duration: 100000 });
      setTimeout(() => {
        let url = `user/complete-profile`;
        if (this.$store.getters.systemStatus === 0) {
          FhsAxios.get(url, {
            data: {}
          }).then(res => {
            this.$toasted.clear();
            if (res.data.status) {
              this.complete = true;
              this.$toasted.success(this.$t("registration completed"));
              return;
            }
            this.$toasted.error(this.$t("error"));
          });
        }
      }, 2000);
    }
  },
  mounted() {}
};
</script>

<style scoped>
.lk-container {
  color: #ffffff;
}

.title {
  text-align: center;
}

.paragraph {
  margin-top: 30px;
  font-size: 14px;
  text-align: center;
}
</style>
